import type { SharedData } from "@/types";
import { usePage } from "@inertiajs/react";

type PermissionEnum = App.Enums.PermissionEnum;

/**
 * Hook to check permissions programmatically
 * Uses the permissions shared through Inertia from the backend
 */
export function usePermissions() {
  const { auth } = usePage<SharedData>().props;
  const userPermissions = (auth?.permissions || []) as PermissionEnum[];

  const can = (permission: PermissionEnum): boolean => {
    return userPermissions.includes(permission);
  };

  const canAny = (permissions: PermissionEnum[]): boolean => {
    return permissions.some((perm) => userPermissions.includes(perm));
  };

  const canAll = (permissions: PermissionEnum[]): boolean => {
    return permissions.every((perm) => userPermissions.includes(perm));
  };

  const cannot = (permission: PermissionEnum): boolean => {
    return !can(permission);
  };

  return { can, canAny, canAll, cannot, permissions: userPermissions };
}
